type StatusCarrier = {
  status?: unknown;
};

export const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const { status } = error as StatusCarrier;

  return typeof status === "number" ? status : undefined;
};

export const isClientErrorStatus = (status: number | undefined): boolean => {
  return typeof status === "number" && status >= 400 && status < 500;
};

export const isServerErrorStatus = (status: number | undefined): boolean => {
  return typeof status === "number" && status >= 500 && status < 600;
};

export const isStatus = (error: unknown, ...statuses: number[]): boolean => {
  const status = getErrorStatus(error);

  return typeof status === "number" && statuses.includes(status);
};

export const isAbortError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  return "name" in error && (error as { name?: string }).name === "AbortError";
};
